import { noop } from '../app/utils/utils';

export const UAParser = noop;

const uaParserMock = {
    UAParser,
};

export default uaParserMock;
